import instamapsBreadcrumbs from '../shared/components/breadcrumbs/breadcrumbs.vue';
import instamapsMessageModal from '../shared/components/message-modal/message-modal.vue';
import messages from './renovar-translations';
import { RenovarService } from './services/renovarService';

export default {
    name: 'instamapsRememberPassword',
    data: () => {
        return {
            modalIsError: false,
            modalIsLoaded: false,
            modalTitle: "",
            modalMessage: "",
            form: {
                email: '',
                pass: '',
                confirmpass: '',
                token: "",
            },
        };
    },
    i18n: {
        messages,
    },
    components: {
        instamapsBreadcrumbs,
        instamapsMessageModal,
    },
    props: {
        hasBreadcrumbs: { type: Boolean },
    },
    methods: {
        renovar: function(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                  let data = {
                    email: this.form.email,
                    token: this.form.token,
                    newPassword: this.form.pass,
                  };
                  RenovarService.httpPostRenovar(data).then((response) => {
                    if (response.status==="OK") {
                        this.showModalOK();
                    }else{
                        this.showModalError();
                    }
                  }).catch(() => {
                    this.showModalError();
                  });
                }
            });
        },
        loaded: function(){
            if(!this.modalIsError){
                this.$emit('toLogin');
            }
            this.modalIsError = false;
            this.modalIsLoaded = false;
        },
        showModalError: function(){
            this.modalTitle = this.$t('titleErrorRenovar');
            this.modalMessage = this.$t('messageErrorRenovar');
            this.modalIsError = true;
            this.modalIsLoaded = true;
        },
        showModalOK: function(){
            this.modalTitle = this.$t('titleOkRenovar');
            this.modalMessage = this.$t('messageOkRenovar');
            this.modalIsError = false;
            this.modalIsLoaded = true;
        },
    },
    mounted() {
       this.form.token = this.$route.params.token;
    },
};



// WEBPACK FOOTER //
// ./src/renovar/renovar.js